import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type { RxItem } from "../../network/usePrescriptions";

interface CreateFollowUpParams {
  pharmacyId: string;
}

interface CreateFollowUpResponse {
  rxItems: RxItem[];
}

export const useBatchApplyPharmacy = ({
  patientId,
  encounterId,
}: {
  patientId: string;
  encounterId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<CreateFollowUpResponse, CreateFollowUpParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Prescriptions.BATCH_APPLY_PHARMACY(
        patientId,
        encounterId,
      ),
      mutationFn: (params) => {
        return axiosInstance.patch("/rx/prescriptions/batch-update-pharmacy", {
          encounterId,
          pharmacyId: params.pharmacyId,
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.Prescriptions.DEFAULT_PATIENT(patientId),
        });
      },
    },
  });
};
